import React, { ChangeEvent, useMemo } from 'react';
import { Input } from '.';

function MaskedInput({ value, onChange, mask, ...props }: any) {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const cleanValue = e.target.value.replace(/[^\d]/g, '');
    const eventCopy = { ...e };
    const trimmedValue =
      cleanValue.length > maskLength ? cleanValue.slice(0, -1) : cleanValue;
    eventCopy.target.value = trimmedValue;
    onChange!(eventCopy);
  };

  const maskLength: number = useMemo(() => {
    return mask.replace(/[^#]/g, '').length;
  }, [mask]);

  return (
    <>
      <Input
        {...props}
        value={format(value as string, mask)}
        onChange={handleChange}
      />
    </>
  );
}

export default MaskedInput;

const format = (str = '', mask: string = '') => {
  let i = 0;
  let lastReplacedIndex = -1;
  const filledMask = mask.replace(/#/g, (_, j) => {
    if (i >= str.length) return '#';
    lastReplacedIndex = j;
    return str[i++];
  });

  return filledMask.substring(0, lastReplacedIndex + 1);
};
